document.addEventListener('DOMContentLoaded', () => {
  const configuracao = $('input[name="configuracao[exibir_indicadores_rentabilidade_simulacao_pre_custo]"]');
  if (configuracao.length < 1) return;

  const bsSwitch = configuracao.parent().find('.bootstrap-switch');
  if (bsSwitch.length < 1) return;

  bsSwitch.on('switchChange.bootstrapSwitch', function(event, state) {
    const { cnpj, email } = configuracao.eq(1).data() || {};
    sendEventExibeMarkupSimulacaoPreCusto(cnpj, email, state);
  });

  moveToSelecionarECpf();
});

function sendEventExibeMarkupSimulacaoPreCusto(cnpj, email, state) {
  const posthogEvent = state ? 'Exibir markup no PDF da simulação de pré-custo' : 'Ocultar markup no PDF da simulação de pré-custo';
  const detail = { posthogEvent, trackCnpj: cnpj, trackEmail: email };
  const event = new CustomEvent("posthog:capture", { detail });
  document.dispatchEvent(event);
}

function moveToSelecionarECpf() {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.has('selecionar_ecpf')) {
    const selecionarECpf = document.getElementById('configuracao_pessoa_certificado_para_monitoramento_aduaneiro_id');
    if (selecionarECpf) {
      const { top } = selecionarECpf.getBoundingClientRect();
      window.scrollTo({
        top: top + window.pageYOffset,
        behavior: 'smooth',
      });
    }
  }
}
